export default __webpack_public_path__ + "static/media/img9.4cf035b4.jpg";